import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import {
  getTrend,
  getTrendColor,
  cardStyle,
  titleStyle,
  valueContainerStyle,
  prevMonthContainerStyle,
  arrowStyle,
  prevMonthInfoStyle,
  currentMonthValueStyle,
} from './stat-card-utils'

/**
 * 回答数カードコンポーネント
 * 現在月の回答数と前月比を表示
 */
type Props = {
  title: string
  currentMonthValue: number
  momRate?: number
  prevMonthValue?: number
}

export const AnswerCountCard = ({ title, currentMonthValue, momRate, prevMonthValue }: Props) => {
  const { t } = useTranslation()

  const prevMonthValueDisplay: string = useMemo(() => {
    if (!prevMonthValue) {
      return '-'
    }
    return prevMonthValue.toLocaleString()
  }, [prevMonthValue])

  const currentMonthValueDisplay: string = useMemo(() => {
    return currentMonthValue.toLocaleString()
  }, [currentMonthValue])

  const momRateDisplay: string = useMemo(() => {
    if (!momRate) {
      return '-'
    }
    const displayMomRate = 100 + momRate
    return `${displayMomRate.toFixed(1)}%`
  }, [momRate])

  const trend = useMemo(() => getTrend(momRate), [momRate])
  const trendColor = useMemo(() => getTrendColor(trend), [trend])
  const trendColorStyle = useMemo(() => css({ color: trendColor }), [trendColor])

  return (
    <div css={cardStyle}>
      <div css={titleStyle}>{title}</div>
      <div css={valueContainerStyle}>
        <div css={currentMonthValueStyle}>{currentMonthValueDisplay}</div>
        <div css={[prevMonthContainerStyle, trendColorStyle]}>
          <span css={arrowStyle}>{trend === 'up' ? '⬆︎' : trend === 'down' ? '⬇︎' : ''}</span>
          <span css={prevMonthInfoStyle}>
            {t('PrevMonthComparison', { rate: '' }).trim()}
            <br />
            {`${momRateDisplay}(${prevMonthValueDisplay})`}
          </span>
        </div>
      </div>
    </div>
  )
}
